import React from 'react'
import { useFormikContext, Form } from 'formik'
import { useContext, useState } from 'react'
import { FaPlus, FaTrash } from 'react-icons/fa'
import { Text, Flex, Box, Button, IconButton } from 'theme-ui'
import { Table } from '../../../components'
import { InputComponent } from '../../../components/Input/Input'
import { TextareaComponent } from '../../../components/Input/Textarea'
import { PanelComponent } from '../../../components/Panel/Panel'
import { newUuid } from '../../../utils'
import { ReportContext, ReportFormValues } from './ReportForm'
import { date } from '../../../utils/formatter'
import dayjs from 'dayjs'
import { isEmpty } from 'lodash'

const MIN_DATE = '2018-06-01'

function TimeOfEvents() {
  const context = useContext(ReportContext)
  const [state, setState] = useState<
    ReportFormValues['timeOfEvents']['valueName'][0]
  >({
    tanggal: '',
    keterangan: '',
  })
  const { values, setFieldValue, errors } = useFormikContext<ReportFormValues>()
  const timeOfEvents = values.timeOfEvents

  function addTime(e) {
    e.preventDefault()
    e.stopPropagation()

    setFieldValue('timeOfEvents.valueName', [
      ...timeOfEvents?.valueName,
      { ...state, id: newUuid() },
    ])
    setState({ tanggal: '', keterangan: '' })
  }

  return (
    <PanelComponent
      id="timeOfEvents"
      header="Kapan Terjadinya?"
      variant={errors.timeOfEvents?.valueName ? 'error' : 'primary'}
      childPadding={[1, null, null]}
    >
      <Text color="error">{errors.timeOfEvents?.valueName}</Text>

      {context.state === 'editing' && (
        <Form onSubmitCapture={addTime}>
          <Flex sx={{ alignItems: 'end', gap: 2 }}>
            <Box sx={{ flex: 2 }}>
              <InputComponent
                required
                label="Waktu Kejadian"
                onChange={(e) =>
                  setState((prev) => ({ ...prev, tanggal: e.target.value }))
                }
                value={state.tanggal}
                type="date"
                min={dayjs(MIN_DATE).format('YYYY-MM-DD')}
                max={dayjs(new Date()).format('YYYY-MM-DD')}
              />
            </Box>
            <Box sx={{ flex: 2 }}>
              <TextareaComponent
                required
                label="Keterangan"
                onChange={(e) =>
                  setState((prev) => ({ ...prev, keterangan: e.target.value }))
                }
                value={state.keterangan}
                sx={{ height: 55 }}
              />
            </Box>
            <Box sx={{ flex: 1, textAlign: 'right' }}>
              <Button type="submit">
                <Box as={FaPlus} pt="1" />{' '}
                <Box as="span" sx={{ display: ['none', 'inline'] }}>
                  Tambah
                </Box>
              </Button>
            </Box>
          </Flex>
        </Form>
      )}

      {!isEmpty(timeOfEvents.valueName) && (
        <Table
          disablePagination
          options={{
            initialState: { pageSize: 5 },
            columns: [
              { Header: 'No', width: '5%', Cell: ({ row }) => row.index + 1 },
              {
                Header: 'Tanggal',
                Cell: ({ row }) => date(row.original.tanggal),
              },
              { Header: 'Keterangan', accessor: 'keterangan' },
              ...(context.state === 'editing'
                ? [
                    {
                      Header: 'Aksi',
                      Cell: function (props) {
                        const id = props.row.original.id

                        const handleDelete = () => {
                          const times = timeOfEvents?.valueName?.filter(
                            (data) => data.id !== id
                          )
                          setFieldValue('timeOfEvents.valueName', times)
                        }

                        return (
                          <IconButton onClick={handleDelete}>
                            <FaTrash size={45} />
                          </IconButton>
                        )
                      },
                      width: '10%',
                    },
                  ]
                : []),
            ],
            data: timeOfEvents.valueName,
          }}
        />
      )}
    </PanelComponent>
  )
}

export default TimeOfEvents
